import styled from 'styled-components';

export const HomeSection = styled.main`
  height: calc(100vh - 70px);
  display: flex;

  @media screen and (max-width: 900px) {
    flex-direction: column-reverse;
    justify-content: center;
  }
`;

export const Wrapper = styled.div`
  max-width: 750px;
  display: flex;
  flex-direction: column;
  justify-content: center;

  @media screen and (max-width: 900px) {
    text-align: center;
    margin: 1rem auto;
  }
`;

export const SmallText = styled.p`
  margin-top: 1rem;
  display: block;
  max-width: 500px;

  @media screen and (max-width: 900px) {
    margin: 0 auto;
  }
`;

export const ButtonGroup = styled.div`
  margin: 2.5rem 0;
  display: flex;
  align-items: center;

  @media screen and (max-width: 900px) {
    justify-content: center;
    margin: 1.5rem 0;
  }

  @media screen and (max-height: 600px) {
    margin: 1rem 0;
  }
`;

export const SocialLinksWrapper = styled.div`
  display: flex;
  align-items: center;
  justify-content: space-between;
  width: 250px;
  margin: 0;

  @media screen and (max-width: 900px) {
    width: 200px;
    margin: 0 auto;
  }

  @media screen and (max-height: 600px) {
    width: 180px;
  }

  @media screen and (max-height: 600px) and (min-width: 900px) {
    width: 230px;
  }
`;

export const WavingEmoji = styled.span`
  animation-name: wave-animation;
  animation-duration: 2.5s;
  animation-iteration-count: infinite;
  transform-origin: 70% 70%;
  display: inline-block;
  font-size: 1.5rem;

  @keyframes wave-animation {
    0% {
      transform: rotate(0deg);
    }
    10% {
      transform: rotate(14deg);
    }
    20% {
      transform: rotate(-8deg);
    }
    30% {
      transform: rotate(14deg);
    }
    40% {
      transform: rotate(-4deg);
    }
    50% {
      transform: rotate(10deg);
    }
    60% {
      transform: rotate(0deg);
    }
    100% {
      transform: rotate(0deg);
    }
  }
`;

export const SvgImg = styled.img`
  width: 400px;

  @media screen and (max-width: 900px) {
    width: 250px;
    margin: 0 auto;
  }

  @media screen and (max-width: 440px) {
    width: 160px;
  }

  @media screen and (max-width: 360px) {
    width: 140px;
  }

  @media screen and (max-height: 500px) {
    width: 82px;
  }
`;
